import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dash from "./pages/Dash";

import Downline from "./pages/Downline";

import Profile from "./pages/Profile";
import Wallet from "./pages/wallet/Wallet";
import Support from "./pages/Support";
import NotFound from './pages/NotFound';
import Ticket from './pages/Ticket';
import Wallet2 from './pages/wallet/Wallet2';
import Packagebuy from './pages/package/packagebuy'

import Investbuy from './pages/package/investbuy';
import PrivateRoute from './pages/PrivateRoute';
import Package from './pages/package';

import Income from "./pages/income/Income";
import Statments from "./pages/income/Statments";
import Direct from './pages/income/Direct';
import Binary from './pages/income/Binary';
import Spbinary from './pages/income/Spbinary';
import Reward from './pages/income/Reward';
import Club from './pages/income/Club';
import Smm from './pages/income/Smm';
import Self from './pages/income/Self';
import Level from './pages/income/Level';
import Task from './pages/task/task';

import Product from './pages/product/product';
import Cart from './pages/product/cart';
import ProductReBuy from './pages/product/productrebuy';
import Preproduct from './pages/package/preproduct';
function App() {
  const [ipAddress] = useState("108.108.108.108");
  const [token, setToken] = useState('');
  const handleLogin = (token) => {
    setToken(token);
  };
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/"><Login ipAddress={ipAddress} onLogin={handleLogin} /></Route>
        <Route path="/register"><Register ipAddress={ipAddress} /></Route>
        <PrivateRoute exact path="/dash" component={Dash} />

        <PrivateRoute exact path="/downline" component={Downline} />

        <PrivateRoute exact path="/profile" component={Profile} />
        {/* Support Rout */}
        <PrivateRoute exact path="/support" component={Support} />
        <PrivateRoute exact path="/ticket" component={Ticket} />
        {/* Package rout */}
        <PrivateRoute exact path="/buypackage" component={Packagebuy} />
        <PrivateRoute exact path="/buyinvest" component={Investbuy} />
        {/* Wallet Rout */}
        <PrivateRoute exact path="/topup" component={Wallet2} />
        <PrivateRoute exact path="/package" component={Package} />
        <PrivateRoute exact path="/wallet" component={Wallet} />
        {/* Income Route */}
        <PrivateRoute exact path="/income" component={Income} />
        <PrivateRoute exact path="/statment" component={Statments} />
        <PrivateRoute exact path="/direct" component={Direct} />
        <PrivateRoute exact path="/binary" component={Binary} />
        <PrivateRoute exact path="/spbinary" component={Spbinary} />
        <PrivateRoute exact path="/reward" component={Reward} />
        <PrivateRoute exact path="/club" component={Club} />
        <PrivateRoute exact path="/smm" component={Smm} />
        <PrivateRoute exact path="/royalty" component={Level} />
        <PrivateRoute exact path="/self" component={Self} />

        <PrivateRoute exact path="/task" component={Task} />
        <PrivateRoute exact path="/product" component={Product} />
        <PrivateRoute exact path="/cart" component={Cart} />
        <PrivateRoute exact path="/rebuy" component={ProductReBuy} />
        <PrivateRoute exact path="/rebuyview" component={Preproduct} />

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
